import { Loading } from "@/components/src/animations/loading";
import { Search } from "lucide-react";
import { Button, Input } from "@mui/material";
import { JobEntityType } from "../../../../lib/supabase/supabaseTypes";
import { showNotification } from "../../store/Central/selectors";
import { Logger } from "@/lib/logger/Logger";
import { supabase } from "@/lib/supabase/supabaseClient";
import React, { useState, useEffect } from "react";
import { useCentralStore } from "../../store/Central";
import { JobItemComponent } from "../../pages/Jobs/job-item.component";
import { useSearchStore } from "../../store/Search";
import { JobSearchResult } from "@/dentlab/src/store/Search/types";

export const JobSelectionWithSearchComponent = ({
  handleSelect
}: {
  handleSelect: (jobId: string) => void;
}) => {
  const { profile } = useCentralStore.getState();
	const { fetchSearchResultsJobs } = useSearchStore.getState();
	const [allJobs, setAllJobs] = useState<JobEntityType[] | JobSearchResult[]>([]);
	const [jobs, setJobs] = useState<JobEntityType[] | JobSearchResult[]>([]);
	const [loading, setLoading] = useState(false);
	const pageSize = 20;
	const [range, setRange] = useState(pageSize);

  const searchJobs = async (query: string) => {
		setLoading(true);
		const jobs = await fetchSearchResultsJobs(query);
		if (query.length == 0) {
			setJobs(allJobs);
			setLoading(false);
			return;
		}
		setJobs(jobs);
		setLoading(false);
	};

  const getJobs = async () => {
		setLoading(true);

		const { data, error } = await supabase
			.from("jobs")
			.select()
			.eq("organization_id", profile?.organization_id as string)
			.order("modified_at", { ascending: false })
			.order("created_at", { ascending: false })
			.range(0, range - 1);

		if (error) {
			Logger.error(error, {}, "Error fetching jobs");
			showNotification({
				message: "Fehler beim Abrufen von Jobs",
				type: "error",
			});
			return;
		}

		setJobs(data);
		setAllJobs(data);
		setLoading(false);
	};

  useEffect(() => {
		getJobs();
	}, [range]);

  
  return (
    <div className="h-full flex flex-col overflow-hidden pb-10">
			<div className="flex-none">
				<div className="flex items-center">
					<Input
						placeholder="Suche"
						endAdornment={<Search size={20} className="mr-2" />}
						onChange={(e) => {
							searchJobs(e.target.value);
						}}
						fullWidth
					/>
				</div>
			</div>
			<div className="flex-1 overflow-y-auto mt-4">
				<div className="flex flex-col gap-2 pb-2">
					{loading && jobs && jobs.length == 0 ? (
						<div className="mt-8">
							<Loading />
						</div>
					) : (
						<>
							{jobs?.length > 0 ? (
								jobs.map((job) => (
									<JobItemComponent
										key={job.id}
										jobTitle={job.title ?? ""}
										jobCode={job.code ?? ""}
										onSelect={() => handleSelect(String(job.id))}
									/>
								))
							) : (
								<div className="text-center py-4">
									Keine Aufträge gefunden
								</div>
							)}
							{!loading && jobs.length === range && (
								<Button
									onClick={() => {
										setRange((prev) => prev + pageSize);
									}}
								>
									Mehr anzeigen
								</Button>
							)}
						</>
					)}
				</div>
			</div>
		</div>
  );
};
